import { blank_layout, base_layout } from '@/admin/layouts'
// 前端路由表
const constantRouterComponents = {
    // 基础页面 layout 必须引入
    BaseLayout: base_layout,
    BlankLayout: blank_layout,
}

const routerMap = [
    { title: '系统管理', component: "BlankLayout", id: 10, icon: 'Menu', name: "system", parentId: 0, },
    { title: '系统配置', component: "/login", id: 110,  icon: 'Setting', name: "test", parentId: 10 },
    { title: '系统状态', component: "/adminComponents/PrintDom", id: 115, icon: 'Setting', name: "test2", parentId: 10 },
    { title: '打印管理', component: "BlankLayout", id: 20, icon: 'User', name: "goodAdmin", parentId: 0, },
    // { title: '分类列表', component: "/Classify", id: 210, icon: 'Document', name: "classify", parentId: 20 },
    // { title: '测试项目', component: "/File2", id: 246, icon: 'Document', name: "file2", parentId: 20 },
    { title: '用户管理', component: "/User", id: 245, icon: 'User', name: "user", parentId: 20 },
    { title: '文件管理', component: "/File", id: 248, icon: 'Files', name: "file", parentId: 20 },

    { title: '提现管理', component: "/upFile/withdrawaRecord", id: 250, icon: 'Setting', name: "withdrawaRecord3", parentId: 20 },
    { title: '订单管理', component: "/Order", id: 240, icon: 'Edit', name: "order", parentId: 20 },
    // { title: '卡密管理', component: "/Card", id: 244, icon: 'Setting', name: "Card", parentId: 20 },
    { title: '订单中心', component: "/OrderCenter", id: 236, icon: 'DocumentCopy', name: "OrderCenter", parentId: 20 },
    { title: '订单操作', component: "/OrderOp", id: 237, icon: 'SetUp', name: "OrderOp", parentId: 20 },
    { title: '订单列表', component: "/order/order_list", id: 310, icon: 'Document', name: "order_list", parentId: 30 },
    { title: '测试311', component: "/test", id: 320, icon: 'Setting', name: "role4", parentId: 30 },
    // { title: '服务管理', component: "BlankLayout", id: 40, icon: 'Menu', name: "system2", parentId: 0, },
    // { title: '服务项目', component: "/service/service_list", id: 410, icon: 'Setting', name: "service_list", parentId: 40 },
    //{ title: '售后管理', component: "/afterSale", id: 430, icon: 'Setting', name: "afterSale", parentId: 50 },
    { title: '提现管理', component: "/upFile/withdrawaRecord", id: 430, icon: 'Setting', name: "withdrawaRecord", parentId: 50 },


    { title: '代理管理', component: "BlankLayout", id: 50, icon: 'Document', name: "system2", parentId: 0, },

    { title: '优惠券管理', component: "BlankLayout", id: 60, icon: 'Document', name: "system5", parentId: 0, },
    { title: '优惠模板', component: "/Voucher/VoucherTemplate", id: 630, icon: 'Setting', name: "VoucherTemplate", parentId: 60 },
    { title: '优惠券领取', component: "/Voucher/UserVoucher", id: 640, icon: 'Setting', name: "UserVoucher", parentId: 60 },

    // { title: '资料分类', component: "/upFile/upFileClass", id: 510, icon: 'Setting', name: "upFileClass", parentId: 50 },
    // { title: '资料列表', component: "/upFile/upFile", id: 520, icon: 'Setting', name: "upFile", parentId: 50 },
]

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
function generator(routerMap, parent) {
    return routerMap.map(item => {
        const currentRouter = {
            // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
            path: item.path || `/admin/${item.name}`,
            name: item.name || item.key || '',
            component: constantRouterComponents[item.component || item.key] || (() => import(`@/admin${item.component}`)),
            meta: {
                title: item.title,
                icon: item.icon,
            }
        }
        // 是否有子菜单，并递归处理
        if (item.children && item.children.length > 0) {
            currentRouter.children = generator(item.children, currentRouter)
        }
        return currentRouter
    })
}
/**
 * 数组转树形结构
 * @param list 源数组
 * @param tree 树
 * @param parentId 父ID
 */
function listToTree(list, tree, parentId) {
    list.forEach(item => {
        // 判断是否为父级菜单
        if (item.parentId === parentId) {
            const child = {
                ...item,
                key: item.key || item.name,
                children: []
            }
            // 迭代 list， 找到当前菜单相符合的所有子菜单
            listToTree(list, child.children, item.id)
            // 删掉不存在 children 值的属性
            if (child.children.length <= 0) {
                delete child.children
            }
            // 加入到树中
            tree.push(child)
        }
    })
}


export default function createAdminRouters() {

    const routes_tree = []
    //      后端数据, 根级树数组,  根级 PID
    listToTree(routerMap, routes_tree, 0)

    const adminRoutes = generator(routes_tree)

    return adminRoutes
}